import styled from 'styled-components';
import { FC, memo, useCallback } from 'react';

import SkewedButton from '@components/buttons/SkewedButton';
import { TabKey, HOME_TABS } from '@utils/constants/home';
import { useHomeTabs } from '@providers/HomeTabsProvider';

import SuggestedFeed from './SuggestedFeed';
import FollowingFeed from './FollowingFeed';
import ScheduledFeed from './ScheduledFeed';

const Container = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
`;

const TabsContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  margin-bottom: 8px;
  gap: 16px;
  padding-inline: 8px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    position: sticky;
    top: 0;
    z-index: 100;
    background-color: ${({ theme }) => theme.colors.black};
    padding-block: 8px;
    justify-content: space-between;
    padding-inline: 20px;
    padding-top: max(8px, env(safe-area-inset-top));
  }
`;

const Tab = styled(SkewedButton)`
  min-width: 120px;

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    flex: 1;
    min-width: auto;
  }
`;

const ContentContainer = styled.div`
  width: 100%;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  min-height: 0;
`;

const HomeTabs: FC = () => {
  const { activeTab, setActiveTab } = useHomeTabs();

  const renderScene = useCallback(() => {
    switch (activeTab) {
      case TabKey.Suggested:
        return <SuggestedFeed />;
      case TabKey.Following:
        return <FollowingFeed />;
      case TabKey.Scheduled:
        return <ScheduledFeed />;
      default:
        return null;
    }
  }, [activeTab]);

  return (
    <Container>
      <TabsContainer>
        {HOME_TABS.map((tab) => (
          <Tab
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            isGradient={activeTab === tab.id}
          >
            {tab.label}
          </Tab>
        ))}
      </TabsContainer>

      <ContentContainer>{renderScene()}</ContentContainer>
    </Container>
  );
};

export default memo(HomeTabs);
